import React from 'react';
import PropTypes from 'prop-types';

// One cell of the status overview strip: eyebrow label, coloured state line
// (optional leading icon node), one detail line, timestamp. Purely presentational —
// all state derivation stays in page.jsx so the strip reads identically per tile.
const StatusTile = ({
  label, state, colour, icon, detail, timestamp, extra
}) => (
  <div className="bhp-optimiser-status__tile">
    <div className="bhp-optimiser-status__tile-label">
      {label}
      {extra}
    </div>
    <div className="bhp-optimiser-status__tile-state" style={{ color: colour }}>
      {icon}
      <span>{state}</span>
    </div>
    <div className="bhp-optimiser-status__tile-detail">{detail || '—'}</div>
    <div className="bhp-optimiser-status__tile-time">{timestamp || ''}</div>
  </div>
);

StatusTile.propTypes = {
  label: PropTypes.node.isRequired,
  state: PropTypes.node.isRequired,
  colour: PropTypes.string,
  icon: PropTypes.node,
  detail: PropTypes.node,
  timestamp: PropTypes.node,
  extra: PropTypes.node
};

StatusTile.defaultProps = {
  colour: undefined, icon: null, detail: null, timestamp: null, extra: null
};

export default StatusTile;
